import AuthForm from "../components/AuthForm";
import AuthDialog from "../components/AuthDialog";
import { useAuth } from "../hooks/useAuth";

const Auth = () => {
  const {
    phone,
    code,
    inputCode,
    password,
    passwordCheck,
    inputPassword,
    passwordsMatch,
    isTimerActive,
    timer,
    isLogin,
    openDialog,
    dialogMessage,
    setOpenDialog,
    setPhoneValue,
    setCodeValue,
    setPasswordValue,
    setPasswordValueCheck,
    handleDialogClose,
    handleResendCode,
    loginToggle,
    click,
  } = useAuth();
  return (
    <div className="form-container">
      <AuthForm
        isLogin={isLogin}
        phone={phone}
        setPhoneValue={setPhoneValue}
        code={code}
        setCodeValue={setCodeValue}
        inputCode={inputCode}
        password={password}
        setPasswordValue={setPasswordValue}
        passwordCheck={passwordCheck}
        setPasswordValueCheck={setPasswordValueCheck}
        inputPassword={inputPassword}
        isTimerActive={isTimerActive}
        timer={timer}
        passwordsMatch={passwordsMatch}
        handleResendCode={handleResendCode}
        click={click}
        loginToggle={loginToggle}
      />
      <AuthDialog
        isOpen={openDialog}
        onOpenChange={setOpenDialog}
        message={dialogMessage}
        onClose={handleDialogClose}
      />
    </div>
  );
};

export default Auth;
